<div class="cart-preview-card animated fadeInRight">
  <div class="cart-preview-card__img">
    <a [routerLink]="['/shop/'+(product()?.productUrl || '')]">
      <img [src]="product()?.img || 'assets/images/product-placeholder.webp'" alt="image"
        (error)="handleImageError($event)" />
    </a>
  </div>
  <div class="cart-preview-card__content">
    <a class="title" [routerLink]="['/shop/'+(product()?.productUrl || '')]">
      {{ product().name }}
    </a>
    @if(allowModification()) {
    @if (!product().bundle?.items?.length && product().bundle?.priceRange) {
    <!-- <small class="price">{{ product().bundle.priceRange }}</small> -->
    } @else {
    <small class="price">{{ totalPrice() | currency }}</small>
    }
    }
    @if (!isJustAddedProductNotification()) {
    <!-- DEV-11456: canModify/canRemove fold in the product cut-off, so a line that
         closed early is frozen here too, whatever the caller allows. -->
    <div class="input-plus-minus">
      @if(canModify()) {
      <button class="btn-plusminus" [disabled]="newQuantity() <= 1" (click)="handleMinus()"
        ngbTooltip="Remove Quantity" placement="bottom" tooltipClass="tooltip-sm">-</button>
      }
      <mat-form-field class="d-flex" subscriptSizing="dynamic">
        <input type="text" matInput appNumberRestriction [minNumber]="1" [maxNumber]="100" (keyup)="onKeyUp($event)"
          (keyup.enter)="updateQuantity()" (blur)="updateQuantity()" [disabled]="!canModify()"
          [value]="newQuantity()">
      </mat-form-field>
      @if(canModify()) {
      <button class="btn-plusminus" (click)="handlePlus()" ngbTooltip="Add Quantity" placement="bottom"
        tooltipClass="tooltip-sm">+</button>
      }
    </div>
    }
  </div>

  @if (!isJustAddedProductNotification()) {
  @if (canRemove()) {
  <div class="cart-preview-card__remove">
    <button (click)="removeCartProduct()" [disabled]="isRemoving()" class="cart-delete"><span
        class="material-symbols-outlined">close</span></button>
  </div>
  }

  <!-- DEV-11456: the controls above are disabled rather than hidden; this is what
       explains them. -->
  @if (isCutOffLocked()) {
  <small class="cart-preview-card__cutoff">{{ cutOffLockLabel }}</small>
  }
  }
</div>
